import { api } from './client';

const unwrap = (res) => (res?.data?.data ?? res?.data ?? res);

export async function listBringIntoBook(storyId) {
  return unwrap(await api.get(`/stories/${storyId}/bring-into-book`));
}

export async function acceptBringIntoBook(storyId, body) {
  return unwrap(await api.post(`/stories/${storyId}/bring-into-book/accept`, body));
}

export async function skipBringIntoBook(storyId, body) {
  return unwrap(await api.post(`/stories/${storyId}/bring-into-book/skip`, body));
}

export const bringIntoBookApi = {
  list: listBringIntoBook,
  accept: acceptBringIntoBook,
  skip: skipBringIntoBook,
};
